import { useState, useEffect } from 'react';

const useGetDimensions = myRef => {
	// check if its browser
	const hasWindow = typeof window !== 'undefined';
	const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
	useEffect(() => {
		const getWindowDimensions = () => {
			const width = hasWindow ? window.innerWidth : null;
			const height = hasWindow ? window.innerHeight : null;
			return {
				width,
				height
			};
		};

		const getComponentDimensions = () => ({
			width: myRef?.current?.offsetWidth ?? 0,
			height: myRef?.current?.offsetHeight ?? 0
		});
		// return element width height
		const getDimensions = () => {
			if (myRef) {
				return getComponentDimensions();
			}
			return getWindowDimensions();
		};
		const handleResize = () => {
			setDimensions(getDimensions());
		};
		if (hasWindow || myRef.current) {
			setDimensions(getDimensions());
		}
		// on resize, recalculate
		window.addEventListener('resize', handleResize);
		// remove handler on unmount
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [hasWindow, myRef]);
	return dimensions;
};

export default useGetDimensions;
